import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { Observable, Subscription } from "rxjs";
import { ReleaseNote } from "src/app/model/release-note";
import { AppState } from "src/app/store/app.reducer";
import { selectReleaseNoteList, selectUser } from "src/app/store/user/user.selector";
import { StandardPageLayout } from "../../stdlayoutlib/classes.stdlayoutlib";
import { User } from "src/app/model/user";
import packageJson from 'package.json';

@Component({
	templateUrl: './release-note.dialog.component.html',
})
export class ReleaseNoteDialogComponent implements OnInit, OnDestroy {

	releaseNoteList?: ReleaseNote[];
	releaseNoteList$: Observable<ReleaseNote[]>;
	releaseNoteListSub?: Subscription;

	currentUser?: User;
	user$: Observable<User | undefined>;
	userSub: Subscription | undefined;

	newVersion: boolean = false;
	newVersionError: boolean = false;
	enableBeta: boolean = false;
	sistemVersion: string;

	// design
	screenWidth: number;
	DELTA_ERROR_PIXEL = 7;
	MIN_TWO_BUTTONS_DIALOG_WIDTH = 575 + this.DELTA_ERROR_PIXEL;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
	) {
		this.initSelectors();
	}

	initSelectors(): void {
		this.releaseNoteList$ = this.store.select(selectReleaseNoteList);
		this.user$ = this.store.select(selectUser);
	}

	ngOnInit(): void {
		this.sistemVersion = packageJson.version;
		this.newVersion === false;
		this.releaseNoteListSub = this.releaseNoteList$
			.subscribe(releaseNoteList => {
				this.releaseNoteList = releaseNoteList;
				this.checkNewVersion();
				this.checkErrorNewVersion();
			}
			);
		this.userSub = this.user$?.subscribe(currentUser => {
			this.currentUser = currentUser;
			if (currentUser.JumpFe) {
				this.enableBeta = true;
			}
			this.checkNewVersion();
		});
	}

	closeDialog(): void {
		/*if (this.releaseNoteList !== undefined && this.releaseNoteList.length > 0) {
			this.store.dispatch(UserActions.setFeReleaseVersion({ version: this.releaseNoteList[0].ReleaseVersion }));
		}*/
		this.ref.close();
	}

	ngOnDestroy(): void {
		this.releaseNoteListSub?.unsubscribe();
		this.userSub?.unsubscribe();
	}

	checkNewVersion(): void {
		if (this.currentUser !== undefined && this.currentUser.Email !== undefined &&
			this.currentUser.Email !== '' && (this.currentUser.ReleaseVersion === '' ||
				(this.releaseNoteList !== undefined && this.releaseNoteList.length > 0 &&
					this.currentUser.ReleaseVersion !== this.releaseNoteList[0].ReleaseVersion))) {
			this.newVersion = true;
		} else {
			this.newVersion = false;
		}
	}

	checkErrorNewVersion(): void {
		if (this.releaseNoteList !== undefined && this.releaseNoteList.length > 0 &&
			this.sistemVersion !== this.releaseNoteList[0].ReleaseVersion && !this.sistemVersion.includes('rev')) {
			this.newVersionError = true;
		} else {
			this.newVersionError = false;
		}
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	dynamicButtonWidth(): string {
		return this.screenWidth <= this.MIN_TWO_BUTTONS_DIALOG_WIDTH
			? 'w-full'
			: 'w-16rem';
	}


	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}
}